<template>
  <div class="Nosotros">
    <div class="banner-bg"></div>
    <div class="content-box">
      <div class="content">
        <img class="img41" src="@/assets/home/img41.png" />

        <div style="position: relative; z-index: 9">
          <div class="pagetitle">Acuerdo de Privacidad</div>
          <div class="description">
            El presente Aviso de Privacidad (en adelante, el “Aviso”) se dirige
            a toda persona física que suministre sus Datos Personales en la
            plataforma de Zoriona, S.A. de C.V., SOFOM, E.N.R. (en adelante, el
            “Responsable” o “Nosotros”), ya sea en su nombre o en representación
            de personas morales (en adelante, el “Titular” o “Tú”).
          </div>
          <div class="description">
            Los Datos Personales podrán ser recopilados cuando el Titular
            complete el Formulario de Registro o utilice la Plataforma mediante
            cualquier medio.
          </div>
          <div class="description margin-b20">
            Al acceder, usar o navegar en la Plataforma, usted acepta
            expresamente que sus Datos Personales sean tratados de conformidad
            con los principios de licitud, finalidad y protección establecidos
            en la normativa mexicana, y con los términos descritos en este
            Aviso.
          </div>
          <div class="paragraph">1. Controlador de Datos</div>
          <div class="description">
            Para los fines de este aviso, el responsable del tratamiento de
            datos personales es Zoriona, S.A. de C.V., SOFOM, E.N.R. (domicilio:
            AVENIDA ROBLE 555 PISO 4, VALLE DEL CAMPESTRE, SAN PEDRO GARZA
            GARCIA, NUEVO LEÓN 66265, MÉXICO). Se encargará de recolectar, usar,
            almacenar y transferir tus datos únicamente para los fines descritos
            aquí.
          </div>
          <div class="description">
            Podemos utilizar servicios en la nube; los proveedores de estos
            deben cumplir con medidas de seguridad y protección legalmente
            requeridas.
          </div>
          <div class="description">
            Los datos pueden compartirse con terceros contratados o empresas
            comerciales asociadas, siempre que tengan controles de privacidad
            adecuados y el uso se limite a los fines establecidos en este aviso,
            de conformidad con la normativa mexicana.
          </div>

          <div class="paragraph">2. Datos Personales Recolectados</div>
          <div class="description">
            Recopilamos solo los datos necesarios para ofrecer nuestros
            servicios, clasificados en categorías:
          </div>
          <div class="paragraph">a. Identificación Legal</div>
          <div class="tag">
            Nombre completo, fecha de nacimiento, CURP, RFC, número de INE o
            pasaporte, fotografía del documento oficial.
          </div>
          <div class="paragraph">b. Información Financiera</div>
          <div class="tag">
            Número de cuenta bancaria, CLABE, comprobantes de ingresos (nómina,
            declaración de renta), historial crediticio del Buro de Crédito.
          </div>
          <div class="paragraph">c. Datos laborales personales</div>
          <div class="tag">
            Nivel máximo de educación, estado civil, dirección de contacto,
            correo electrónico, número de teléfono, tipo de empleo, ingreso
            mensual, sector y profesión, forma de pago de salario, día de pago y
            segundo día de pago, entre otros.
          </div>
          <div class="paragraph">d. Contacto y Ubicación</div>
          <div class="tag">
            Dirección residencial, número de teléfono móvil, correo electrónico.
          </div>
          <div class="tag">
            Contacto de emergencia：Nombre, número de teléfono y relación del
            primer contacto, así como el nombre, número de teléfono y relación
            del segundo contacto.
          </div>
          <div class="paragraph">
            e. Datos Biométricos (solo con consentimiento)
          </div>
          <div class="tag">
            Características faciales (para reconocimiento biométrico).
          </div>
          <div class="paragraph">f. Información Técnica</div>
          <div class="tag">
            Modelo de dispositivo, versión del sistema operativo, dirección IP.
          </div>
          <div class="paragraph">g. Uso de la Aplicación</div>
          <div class="tag">
            Registros de sesión, tiempo de uso, interacciones con botones de
            préstamo y errores técnicos (crash logs).
          </div>
          <div class="paragraph">h. Permiso de estado telefónico</div>
          <div class="tag">
            Verifica tu número de teléfono registrado para asegurar
            comunicaciones seguras y detectar fraudes.
          </div>
          <div class="paragraph">i. Permisos WiFi y red</div>
          <div class="tag">
            Detectan sesiones remotas y comportamientos anómalos (ejemplo:
            accesos inusuales) para mejorar la seguridad de tu cuenta y detectar
            fraude.
          </div>
          <div class="paragraph">
            j. Permiso de seguimiento publicitario (IDFA)
          </div>
          <div class="tag">
            Este permiso identifica a los usuarios únicos en anuncios, con fines
            de difusión publicitaria dirigida, monitoreo de eficacia
            publicitaria, control de riesgos de seguridad en la cuenta y
            evaluación de riesgos de fraude.
          </div>
          <div class="description margin-b20">
            No solicitamos directamente la recolección de datos personales
            sensibles, como origen étnico, sangre, estado de salud, creencias
            filosóficas o religiosas, opiniones políticas, afiliación sindical o
            orientación sexual (excepto cuando sean necesarios para prevenir
            problemas de lavado de capitales).
          </div>

          <div class="paragraph">3. Permisos de la Aplicación</div>
          <div class="paragraph">a. Cámara</div>

          <div class="tag">
            <span class="font-weight">Propósito:</span>
            Verificación facial y detección de vida real durante la
            autenticación, con el fin de prevenir fraudes y modelar riesgos para
            garantizar la integridad de los procesos crediticios.
          </div>
          <div class="tag">
            <span class="font-weight">Escenarios:</span>
            Solo se activa cuando solicita un préstamo, según la evaluación de
            nuestro sistema de detección de amenazas.
          </div>
          <div class="tag">
            <span class="font-weight">Opciones:</span>
            Puede deshabilitar y administrar este permiso en Configuración >
            Privacidad > Cámara de su dispositivo.
          </div>
          <div class="paragraph">
            b. IDFA (Identificador Único para Anuncios)
          </div>
          <div class="tag">
            <span class="font-weight">Propósito:</span>
            Identificar usuarios únicos en anuncios para publicidad dirigida,
            monitoreo de eficacia publicitaria y control de riesgos de seguridad
            (detección de fraude en la cuenta).
          </div>
          <div class="tag">
            <span class="font-weight">Escenarios:</span>
            Solo cuando interactúas con anuncios dentro de la app o se generan
            métricas de uso.
          </div>
          <div class="tag margin-b20">
            <span class="font-weight">Opciones:</span>
            Puede deshabilitar el seguimiento en Configuración > Privacidad >
            Anuncios de su dispositivo, aunque esto puede reducir la relevancia
            de los anuncios que recibe.
          </div>

          <div class="paragraph">4. Finalidades del Procesamiento</div>
          <div class="description">
            Los datos se tratan con fines legítimos y previstos en la LFPDPPP:
          </div>
          <div class="tag">
            <span class="font-weight"> Servicios Financieros:</span>
            Evaluación de solicitudes de préstamo, gestión de pagos.
          </div>
          <div class="tag">
            <span class="font-weight">Seguridad y Autenticación:</span>
            Detección de vida real y verificación facial para evitar fraudes
            (uso de datos biométricos solo con consentimiento expreso).
          </div>
          <div class="tag">
            <span class="font-weight">Cumplimiento Legal:</span>
            Reporte a la CNBV, SAT y other autoridades, así como prevención de
            lavado de capitales.
          </div>
          <div class="tag">
            <span class="font-weight">Mejora de Servicios:</span>
            Análisis anónimo de uso de la app para optimizar flujos de
            solicitud.
          </div>
          <div class="tag margin-b20">
            <span class="font-weight">Comunicación Marketing:</span>
            Envío de ofertas personalizadas solo si usted ha otorgado su
            consentimiento previo.
          </div>

          <div class="paragraph">5. Compartición y Transferencia de Datos</div>
          <div class="description">
            De conformidad con el Artículo 37 de la Ley Federal de Protección de
            Datos Personales (LFPDPPP), el Responsable puede transferir datos
            personales sin el consentimiento del Titular en los siguientes casos
            specifically previstos en la normativa:
          </div>
          <div class="paragraph">
            Casos excepcionales de transferencia sin consentimiento:
          </div>
          <div class="description">
            a) Cuando la transferencia esté reglamentada por una Ley federal o
            un Tratado internacional en el que México sea parte;
          </div>
          <div class="description">
            b) Para fines médicos: prevención, diagnóstico, tratamiento médico o
            gestión de servicios sanitarios;
          </div>
          <div class="description">
            c) A sociedades del mismo grupo empresarial (controladoras,
            subsidiarias, afiliadas o matriz) que operen bajo políticas de
            privacidad equivalentes;
          </div>
          <div class="description">
            d) Cuando sea necesaria para cumplir con un contrato firmado en
            beneficio del Titular (entre el Responsable y un tercero);
          </div>
          <div class="description">
            e) En aras de un interés público o para apoyar procesos de justicia
            (ejemplo: cooperación con autoridades);
          </div>
          <div class="description">
            f) Para defender derechos en un juicio (reconocimiento, ejercicio o
            defensa legal);
          </div>
          <div class="description">
            g) Para mantener o cumplir una relación jurídica existente entre el
            Responsable y el Titular (ejemplo: cumplimiento de obligaciones
            contractuales).
          </div>
          <div class="paragraph">Obligaciones del Responsable:</div>

          <div class="tag">
            Antes de transferir datos a terceros nacionales o extranjeros (no
            incluidos proveedores o encargados), se le informará al Titular:
          </div>
          <div class="tag">El aviso de privacidad del tercero receptor;</div>
          <div class="tag">
            Las finalidades específicas de la transferencia.
          </div>
          <div class="paragraph">
            Consentimiento requerido en casos no previstos:
          </div>
          <div class="tag margin-b20">
            Para transferencias que no caigan en los casos del Artículo 37, se
            solicitará el consentimiento expreso del Titular, conforme a los
            principios de la Ley.
          </div>

          <div class="paragraph">6. Derechos ARCO y Ejercicio</div>
          <div class="description margin-b20">
            Según la LFPDPPP, como titular de datos, usted tiene los siguientes
            derechos:
          </div>
          <div class="tag">
            <span class="font-weight">Acceso:</span>
            Solicitar copia de sus datos mediante correo o formulario en la app.
          </div>
          <div class="tag">
            <span class="font-weight">Rectificación:</span>
            Corregir información inexacta (ejemplo: error en la dirección).
          </div>
          <div class="tag">
            <span class="font-weight">Supresión:</span>
            Solicitar la eliminación de datos una vez finalizado el servicio,
            salvo obligaciones legales.
          </div>
          <div class="tag">
            <span class="font-weight">Oposición:</span>
            Oponerse al uso de datos para marketing.
          </div>
          <div class="tag">
            <span class="font-weight">Portabilidad:</span>
            Recibir sus datos en formato digital estructurado (CSV, JSON).
          </div>
          <div class="paragraph">Cómo ejercerlos</div>
          <div class="paragraph">Canales de contacto</div>
          <div class="description">
            Gestiona tus derechos sobre datos mediante:
          </div>
          <div class="tag">Correo: servicio@zorionasofom.com</div>
          <div class="tag">
            Teléfono: +52 5573628956 (lunes-viernes, 9:00–18:00 CDT).
          </div>
          <div class="description">
            Si desea eliminar sus datos de la cuenta de forma autónoma, ingrese
            al sitio web oficial > Eliminar cuenta y complete los datos de
            registro para enviar la solicitud.
          </div>
          <div class="paragraph">Protección de datos</div>
          <div class="description">
            Para obtener información detallada sobre sus derechos ARCO (Acceso,
            Rectificación, Cancelación y Oposición) o asegurar su ejercicio,
            contacte directamente con nuestra Oficial de Protección de Datos:
          </div>
          <div class="tag">Nombre: Carolina Sofía García Pérez</div>
          <div class="tag">Correo electrónico: carolina@zorionasofom.com</div>
          <div class="tag">
            Función: Se especializa en garantizar el cumplimiento de la Ley
            Federal de Protección de Datos y responder a solicitudes
            relacionadas con la protección de sus datos personales.
          </div>
          <div class="paragraph">Plazo</div>
          <div class="description margin-b20">
            Respondemos dentro de 15 días hábiles; en casos complejos, se
            extiende a 30 días con notificación previa.
          </div>

          <div class="paragraph">7. Seguridad de Datos</div>
          <div class="tag">
            Cifrado de datos: Utilizamos AES-256 en reposo y TLS 1.3 en
            tránsito.
          </div>
          <div class="tag">
            Acceso restringido: Solo personal autorizado puede acceder a datos
            sensibles.
          </div>
          <div class="tag">
            Auditorías internas: Realizadas trimestralmente por terceros
            certificados.
          </div>

          <div class="paragraph">8. Retención de Datos</div>
          <div class="description">
            Los datos se conservan por períodos establecidos por la normativa:
          </div>
          <div class="tag">
            <span class="font-weight">Préstamos activos: </span>
            Hasta la liquidación total de la deuda.
          </div>
          <div class="tag">
            <span class="font-weight">Préstamos finalizados:</span>
            1 año después de la cancelación.
          </div>
          <div class="tag">
            <span class="font-weight">Logs técnicos: </span>
            90 días, solo para análisis de fallos.
          </div>
          <div class="tag">
            <span class="font-weight">Consentimientos de marketing: </span>
            Eliminados inmediatamente si el usuario revoca su autorización.
          </div>
          <div class="tag margin-b20">
            <span class="font-weight">Datos de menores: </span>
            Eliminados dentro de 72 horas de la detección del registro no
            autorizado.
          </div>

          <div class="paragraph">9. Cambios en la Política</div>
          <div class="description">
            El Responsable podrá actualizar este Aviso en cualquier momento,
            siempre y cuando las modificaciones sean legitimas y en conformidad
            con la normativa mexicana de protección de datos.
          </div>
          <div class="description">
            Cualquier cambio significativo se reflejará en la versión publicada
            en la App Lumi, junto con la fecha de última actualización. Le
            recomendamos revisar periódicamente el Aviso para estar informado de
            los términos que rigen el tratamiento de sus datos personales.
          </div>
          <div class="description margin-b20">
            En caso de dudas sobre las modificaciones, puede contactarnos a
            través de los canales indicados en la sección "Contacto y
            Denuncias".
          </div>
          <div class="paragraph">10. Contacto y Denuncias</div>
          <div class="description">
            Si el Titular desea obtener más información, solver dudas, ejercer
            sus Derechos ARCO (Acceso, Rectificación, Cancelación y Oposición) o
            aclarar cómo gestionar sus datos personales, puede contactarnos de
            inmediato mediante:
          </div>
          <div class="tag">
            <span class="font-weight">Servicio al Cliente:</span>
            servicio@zorionasofom.com | +52 5573628956
          </div>
          <div class="tag">
            <span class="font-weight">Domicilio:</span>
            AVENIDA ROBLE 555 PISO 4, VALLE DEL CAMPESTRE, SAN PEDRO GARZA
            GARCIA, NUEVO LEÓN 66265, MÉXICO
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Nosotros',
  components: {},
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {},
};
</script>

<style scoped>
.banner-bg {
  height: 474px;
  background: linear-gradient(180deg, #9bbce7 0%, #c5dbf7 42%, #eff6ff 100%);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
}
.banner {
  padding: 0 360px;
  margin-top: 70px;
}
.banner-box {
  height: 84px;
  background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
  border-radius: 34px 34px 0px 0px;
  padding: 28px 45px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  position: relative;
}

.print1 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 170px;
  top: 8px;
}
.print2 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 650px;
  top: 8px;
}
.print3 {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #1b67c8;
  position: absolute;
  left: 1040px;
  top: 8px;
}
.banner-box div {
  font-size: 16px;
  color: #977f6a;
  cursor: pointer;
  margin-bottom: 0 !important;
}
.muen1 {
  padding-left: 50px;
}
.muen2 {
  padding-left: 100px;
}
.muen3 {
  padding-right: 40px;
}
.tag {
  position: relative;
  padding: 0 20px;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
}
.tag::after {
  content: ' ';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(270deg, #287bdb 0%, #1156b9 100%);
  position: absolute;
  left: 0;
  top: 8px;
}

.content-box {
  padding: 0 360px;
  margin-bottom: 100px;
  margin-top: 70px;
}
.content {
  padding: 30px;
  background-color: white;
  position: relative;
  border-radius: 20px;
}
.img41 {
  position: absolute;
  width: 1090px;
  top: 50%;
  transform: translateY(-50%);
}

.description {
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
  z-index: 99999;
}
.paragraph {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  margin-bottom: 6px;
  z-index: 9;
}
.margin-b8 {
  margin-bottom: 8px;
}
.margin-b20 {
  margin-bottom: 20px;
}
.font-weight {
  font-weight: bold;
  color: #000000 !important;
}
.c-table {
  border: 1px solid #979797;
  margin-bottom: 14px;
}
.row {
  height: 64px;
  border-bottom: 1px solid #979797;
  padding: 0 26px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.row span {
  display: flex;
  align-items: center;
}

.pagetitle {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 28px;
}

@media (max-width: 768px) {
  .pagetitle {
    font-size: 80px;
    margin-bottom: 42px;
    text-align: center;
  }
  .content-box {
    padding: 0 140px;
  }
  .paragraph {
    font-size: 65px;
    line-height: 110px;
    margin: 20px 0;
  }
  .img41 {
    width: 100%;
  }
  .description {
    font-size: 65px;
    line-height: 120px;
  }

  .banner {
    padding: 0 140px;
  }
  .banner-box {
    height: 384px;
    background: linear-gradient(225deg, #fff8f2 0%, #ffe7d3 46%, #fff8f2 100%);
    border-radius: 34px 34px 0px 0px;
    display: flex;
    align-items: center;
    position: relative;
  }

  .banner-box div {
    font-size: 65px;
    color: #977f6a;
    cursor: pointer;
    margin-right: 0;
    flex: 1;
    text-align: center;
  }
  .tag {
    font-size: 65px;
    line-height: 120px;
    margin-right: 0;
    padding-left: 60px;
  }
  .tag::after {
    content: ' ';
    width: 25px;
    height: 25px;
    top: 50px;
    left: 0;
  }
  .img32 {
    display: none;
  }
}
</style>
